module.exports = __webpack_public_path__ + "img/card-contract-hover.9c1806fb.svg";